// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Facturacion page — colocated styles ────────────────────────────────── */

/* Tab panel spacing */
.fac-tab-panel {
  padding-top: 24px;
}

/* ── KPI row ─────────────────────────────────────────────────────────────── */

.fac-kpi-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 24px;
}

@media (max-width: 600px) {
  .fac-kpi-row {
    grid-template-columns: 1fr;
  }
}

.fac-kpi {
  display: flex;
  flex-direction: column;
  min-height: 108px;
  border: 1px solid var(--border);
  background: var(--surface);
  border-radius: var(--r-data);
  padding: 18px 20px;
}

/* Card hairline reads slightly warmer than --border on navy. */
[data-theme='dark'] .fac-kpi {
  border-color: var(--ink-rule);
}

.fac-kpi__label {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 8px;
}

.fac-kpi__value {
  font-family: var(--display);
  font-weight: 300;
  font-size: var(--fs-kpi);
  line-height: 1;
  letter-spacing: -0.03em;
  color: var(--text);
  margin-bottom: 4px;
}

.fac-kpi__note {
  font-size: var(--fs-xs);
  color: var(--text-muted);
  margin-top: auto;
  padding-top: 8px;
}

/* ── Fee-tiers card ──────────────────────────────────────────────────────── */

.fac-card {
  border: 1px solid var(--border);
  background: var(--surface);
  border-radius: var(--r-data);
  overflow: hidden;
}

[data-theme='dark'] .fac-card {
  border-color: var(--ink-rule);
}

.fac-card__head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 16px 20px 12px;
  border-bottom: 1px solid var(--border);
}

[data-theme='dark'] .fac-card__head {
  border-color: var(--ink-rule);
}

.fac-card__title {
  font-size: var(--fs-note);
  font-weight: 600;
  color: var(--text);
}

.fac-card__hint {
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  color: var(--text-muted);
}

.fac-table-wrap {
  overflow-x: auto;
}

.fac-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--fs-detail);
}

.fac-table th {
  text-align: left;
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted);
  padding: 10px 20px;
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
}

[data-theme='dark'] .fac-table th {
  border-color: var(--ink-rule);
}

.fac-table td {
  padding: 12px 20px;
  color: var(--text-secondary);
  border-bottom: 1px solid var(--border);
  vertical-align: middle;
}

[data-theme='dark'] .fac-table td {
  border-color: var(--ink-rule);
}

.fac-table tr:last-child td {
  border-bottom: 0;
}

.fac-table__num {
  text-align: right;
}

/* Active row highlight */
.fac-table tr.row--on td {
  background: var(--accent-soft);
  color: var(--text);
  font-weight: 500;
}

/* ── tag / tag--ok (inline badge) ───────────────────────────────────────── */

.tag {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 1px 7px;
  font-family: var(--mono);
  font-size: var(--fs-nano);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  border-radius: var(--radius-0);
  vertical-align: middle;
}

.tag--ok {
  background: transparent;
  color: var(--ok);
  border: 1px solid var(--ok);
}

[data-theme='dark'] .tag--ok {
  background: rgba(17, 122, 57, 0.18);
  color: var(--ok);
}

/* ── Card foot note ─────────────────────────────────────────────────────── */

.fac-card__foot {
  font-size: var(--fs-meta);
  color: var(--text-muted);
  padding: 12px 20px;
  margin: 0;
  border-top: 1px solid var(--border);
}

[data-theme='dark'] .fac-card__foot {
  border-color: var(--ink-rule);
}

/* ── Comprobantes wrapper ───────────────────────────────────────────────── */
/* Hosts ComprobantesPago (platform receipts). */
.fac-comprobantes {
}

/* ── Datos tributarios ─────────────────────────────────────────────────── */
/* Read-only field grid hosted inside a .fac-card, so the tab matches the
   Tarifa card look instead of the Configuracion .cfg-section pattern. */
.fac-datos__edit {
  margin-left: auto;
  align-self: center;
}

.fac-datos__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 240px), 1fr));
  gap: 18px 32px;
  padding: 22px 20px;
}

@media (max-width: 560px) {
  .fac-datos__grid {
    grid-template-columns: 1fr;
    gap: 14px;
    padding: 18px 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/facturacion/Facturacion.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E,sBAAsB;AACtB;EACE,iBAAiB;AACnB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8EAA8E;;AAE9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,8EAA8E;;AAE9E;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;EACT,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,8EAA8E;AAC9E,gDAAgD;AAChD;AACA;;AAEA,6EAA6E;AAC7E;wEACwE;AACxE;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;AACF","sourcesContent":["/* ── Facturacion page — colocated styles ────────────────────────────────── */\n\n/* Tab panel spacing */\n.fac-tab-panel {\n  padding-top: 24px;\n}\n\n/* ── KPI row ─────────────────────────────────────────────────────────────── */\n\n.fac-kpi-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 24px;\n}\n\n@media (max-width: 600px) {\n  .fac-kpi-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.fac-kpi {\n  display: flex;\n  flex-direction: column;\n  min-height: 108px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  border-radius: var(--r-data);\n  padding: 18px 20px;\n}\n\n/* Card hairline reads slightly warmer than --border on navy. */\n[data-theme='dark'] .fac-kpi {\n  border-color: var(--ink-rule);\n}\n\n.fac-kpi__label {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin-bottom: 8px;\n}\n\n.fac-kpi__value {\n  font-family: var(--display);\n  font-weight: 300;\n  font-size: var(--fs-kpi);\n  line-height: 1;\n  letter-spacing: -0.03em;\n  color: var(--text);\n  margin-bottom: 4px;\n}\n\n.fac-kpi__note {\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n  margin-top: auto;\n  padding-top: 8px;\n}\n\n/* ── Fee-tiers card ──────────────────────────────────────────────────────── */\n\n.fac-card {\n  border: 1px solid var(--border);\n  background: var(--surface);\n  border-radius: var(--r-data);\n  overflow: hidden;\n}\n\n[data-theme='dark'] .fac-card {\n  border-color: var(--ink-rule);\n}\n\n.fac-card__head {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  padding: 16px 20px 12px;\n  border-bottom: 1px solid var(--border);\n}\n\n[data-theme='dark'] .fac-card__head {\n  border-color: var(--ink-rule);\n}\n\n.fac-card__title {\n  font-size: var(--fs-note);\n  font-weight: 600;\n  color: var(--text);\n}\n\n.fac-card__hint {\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  color: var(--text-muted);\n}\n\n.fac-table-wrap {\n  overflow-x: auto;\n}\n\n.fac-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--fs-detail);\n}\n\n.fac-table th {\n  text-align: left;\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  padding: 10px 20px;\n  border-bottom: 1px solid var(--border);\n  white-space: nowrap;\n}\n\n[data-theme='dark'] .fac-table th {\n  border-color: var(--ink-rule);\n}\n\n.fac-table td {\n  padding: 12px 20px;\n  color: var(--text-secondary);\n  border-bottom: 1px solid var(--border);\n  vertical-align: middle;\n}\n\n[data-theme='dark'] .fac-table td {\n  border-color: var(--ink-rule);\n}\n\n.fac-table tr:last-child td {\n  border-bottom: 0;\n}\n\n.fac-table__num {\n  text-align: right;\n}\n\n/* Active row highlight */\n.fac-table tr.row--on td {\n  background: var(--accent-soft);\n  color: var(--text);\n  font-weight: 500;\n}\n\n/* ── tag / tag--ok (inline badge) ───────────────────────────────────────── */\n\n.tag {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 8px;\n  padding: 1px 7px;\n  font-family: var(--mono);\n  font-size: var(--fs-nano);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  border-radius: var(--radius-0);\n  vertical-align: middle;\n}\n\n.tag--ok {\n  background: transparent;\n  color: var(--ok);\n  border: 1px solid var(--ok);\n}\n\n[data-theme='dark'] .tag--ok {\n  background: rgba(17, 122, 57, 0.18);\n  color: var(--ok);\n}\n\n/* ── Card foot note ─────────────────────────────────────────────────────── */\n\n.fac-card__foot {\n  font-size: var(--fs-meta);\n  color: var(--text-muted);\n  padding: 12px 20px;\n  margin: 0;\n  border-top: 1px solid var(--border);\n}\n\n[data-theme='dark'] .fac-card__foot {\n  border-color: var(--ink-rule);\n}\n\n/* ── Comprobantes wrapper ───────────────────────────────────────────────── */\n/* Hosts ComprobantesPago (platform receipts). */\n.fac-comprobantes {\n}\n\n/* ── Datos tributarios ─────────────────────────────────────────────────── */\n/* Read-only field grid hosted inside a .fac-card, so the tab matches the\n   Tarifa card look instead of the Configuracion .cfg-section pattern. */\n.fac-datos__edit {\n  margin-left: auto;\n  align-self: center;\n}\n\n.fac-datos__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 240px), 1fr));\n  gap: 18px 32px;\n  padding: 22px 20px;\n}\n\n@media (max-width: 560px) {\n  .fac-datos__grid {\n    grid-template-columns: 1fr;\n    gap: 14px;\n    padding: 18px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
